import React, {createRef} from 'react'
import {findDOMNode} from 'react-dom'

import ControlButtonStandard, {
    ControlButtonType
} from "../../../../../gd-components/buttons/control-button/control-button-standard"
import Popover from "../../../../../gd-components/gd-popover/popover-v2"
import PopoverPosition from "../../../../../gd-components/gd-popover/popover-position"
import {PopoverAttachmentType} from "../../../../../gd-components/gd-popover/@const"
import {UsersSelectorGroupBy} from "../../@const"
import {ControlButtonSize} from "../../../../../gd-components/buttons/control-button/@types";

type Props = {
    grouping            : UsersSelectorGroupBy
    selectedCount       : number

    clearHint?          : string

    showCounter?        : boolean

    onChange            : (grouping: UsersSelectorGroupBy) => void
    onCollapseAll       : func
    onExpandAll         : func
    onClearSelection    : func
}

type State = {
    showPopover : boolean
}

const OPTIONS: { value: UsersSelectorGroupBy, label: string, icon: string }[] = [
    { value: UsersSelectorGroupBy.NONE,       label: 'No grouping',  icon: 'i5-users'       },
    { value: UsersSelectorGroupBy.DEPARTMENT, label: 'Department',   icon: 'i5-departments' },
    { value: UsersSelectorGroupBy.TEAMS,      label: 'Teams',         icon: 'i5-team'        },
]

const LABELS: Record<UsersSelectorGroupBy, string> = {
    [UsersSelectorGroupBy.NONE]       : 'Group By',
    [UsersSelectorGroupBy.DEPARTMENT] : 'Department',
    [UsersSelectorGroupBy.TEAMS]      : 'Team',
}

export default class SelectUserGroupingControl extends React.Component<Props, State> {

    private btnRef: any = createRef()

    static defaultProps = {
        clearHint   : 'Clear selection',
        showCounter : true,
    }

    state: State = { showPopover: false }

    onToggle = (e: React.MouseEvent) => {
        e.stopPropagation()
        this.setState(s => ({ showPopover: !s.showPopover }))
    }

    onHide = () => this.setState({ showPopover: false })

    onSelect = (grouping: UsersSelectorGroupBy) => {
        this.props.onChange(grouping)
        this.onHide()
    }

    render() {
        const { grouping, selectedCount } = this.props
        const { showPopover } = this.state
        const isGrouped = grouping !== UsersSelectorGroupBy.NONE

        const popoverPosition = new PopoverPosition({
            attachment      : "top left",
            targetAttachment: "bottom left",
            targetOffset    : "0 0",
            attachmentType  : PopoverAttachmentType.HORIZONTAL,
        })

        return (
            <div className="m-t-10 w-100p flex-row-between-center">

                <div className="flex-row-left-center">

                    <ControlButtonStandard
                        ref         = {this.btnRef}
                        className   = {Classes('p-l-6 p-r-6', { 'show-popover': showPopover })}
                        hint        = "Select users grouping"
                        onClick     = {this.onToggle}
                    >
                        <span className="i5-group-by-2 fs-12 m-r-5"/>
                        <span className="ui5-txt-not-important-small">{LABELS[grouping]}</span>

                        {showPopover &&
                            <Popover position       = {popoverPosition}
                                     getTargetFunc    = {() => findDOMNode(this.btnRef.current)}
                                     onClickOutside   = {this.onHide}>
                                <div className="ui5-popover-menu">
                                    {OPTIONS.map(opt => (
                                        <div key={opt.value}
                                             className={Classes("option with-icon-14", { selected: grouping === opt.value })}
                                             onClick={() => this.onSelect(opt.value)}>
                                            <div className={Classes("ico", opt.icon)}/>
                                            <div className="label">{opt.label}</div>
                                        </div>
                                    ))}
                                </div>
                            </Popover>
                        }
                    </ControlButtonStandard>

                    {isGrouped && <>

                        <div className="ui5-v-separator-dark h-20 m-l-5 m-r-5" />

                        <ControlButtonStandard type    = {ControlButtonType.COLLAPSE_ALL_NEW}
                                               size={ControlButtonSize.SIZE_24}
                                               onClick = {this.props.onCollapseAll}/>

                        <ControlButtonStandard type    = {ControlButtonType.EXPAND_ALL_NEW}
                                               onClick = {this.props.onExpandAll}
                                               size={ControlButtonSize.SIZE_24}

                        />



                    </>}

                </div>

                {selectedCount > 0 &&

                    <div className="flex-row-right-center">

                        {/*<span className="ui5-txt-not-important-small m-r-4">{selectedCount} selected</span>*/}

                        {this.props.showCounter &&
                            <span className="ui5-counter dark m-r-5">{selectedCount}</span>}

                        <ControlButtonStandard
                            type    = {ControlButtonType.DELETE_GRAY}
                            hint    = {this.props.clearHint}
                            onClick = {this.props.onClearSelection}
                        />
                    </div>

                }
            </div>
        )
    }
}
